import { Box, Container } from '@mui/material';
import { useEffect, useState } from 'react';
import { getBubbleSortAnimations, getHeapSortAnimations, getMergeSortAnimations, getQuickSortAnimations } from '../sortingAlgorithms/sortingAlgorithms';
import { randomIntFromInterval } from '../Utiltiy/SortingVisualizer';
import './SortingVisualizer.css';
import SortingBtnGroup from '../SortingBtnGroup/SortingBtnGroup';
import { ANIMATION_SPEED_MS, ARRAY_VALUE_MAX, SECONDARY_COLOR, PRIMARY_COLOR, ARRAY_SIZE_MAX, ANIMATION_SPEED_MAX, SUCCESS_COLOR } from '../Utiltiy/SortSetting';

export default function SortingVisualizer(){
  // Change this value for the number of bars (value) in the array.
  const [arraySize, setArraySize] = useState<number | number[]>(100);
  const [array, setArray] = useState<number[]>([]);
  const [animationSpeed, setAnimationSpeed] = useState<number>(ANIMATION_SPEED_MS);
  const resetArray = () => {
    const array = [];
    for (let i = 0; i < arraySize; i++) {
      array.push(randomIntFromInterval(5, ARRAY_VALUE_MAX));
    }
    setArray(array);
  }


  const resetArrayBarColor = () => {
    const arrayBars = document.getElementsByClassName('array-bar') as HTMLCollectionOf<HTMLElement>;
    for (let i=0;i<arrayBars.length;i++){
      const barOneStyle = arrayBars[i].style;
      barOneStyle.backgroundColor = PRIMARY_COLOR;
    }
  }
  const animateSorting = (callback:(arg0: boolean) => void, animations: any[]) => {
    const arrayBars = document.getElementsByClassName('array-bar') as HTMLCollectionOf<HTMLElement>;
    resetArrayBarColor();
    for (let i = 0; i < animations.length; i++) {
      // const isColorChange = i % 3 !== 2;
      if (!animations[i][2]) {
        const [barOneIdx, barTwoIdx, isSearch, isColor] = animations[i];
        const barOneStyle = arrayBars[barOneIdx].style;
        const barTwoStyle = arrayBars[barTwoIdx].style;
        const color = isColor === true ? SECONDARY_COLOR : PRIMARY_COLOR;
        setTimeout(() => {
          if(barOneStyle.backgroundColor !== color) barOneStyle.backgroundColor = color;
          if(barTwoStyle.backgroundColor !== color) barTwoStyle.backgroundColor = color;
        }, i * animationSpeed);
      } else {
        setTimeout(() => {
          const [barOneIdx, newHeight, isSearch, isColor] = animations[i];
          const barOneStyle = arrayBars[barOneIdx].style;
          barOneStyle.height = `${newHeight}px`;
        }, i * animationSpeed);
      }
    }

    setTimeout(() =>{
      for (let i=0;i<arrayBars.length;i++){
        const barOneStyle = arrayBars[i].style;
        setTimeout(() => {
          barOneStyle.backgroundColor = SECONDARY_COLOR;
        }, i * animationSpeed);
      }
      setTimeout(()=>{
        for (let i=0;i<arrayBars.length;i++){
          const barOneStyle = arrayBars[i].style;
          barOneStyle.backgroundColor = SUCCESS_COLOR;
        }
        callback(false);
      }, arrayBars.length*animationSpeed);
    }, animations.length*animationSpeed);
  }
  const mergeSort = (callback:(arg0: boolean) => void) => {
    const animations = getMergeSortAnimations(array);
    return animateSorting(callback, animations);
  }

  const quickSort = (callback:(arg0: boolean) => void, isRandomPivot=false) => {
    const animations = getQuickSortAnimations(array,isRandomPivot);
    return animateSorting(callback, animations);
  }
  const quickSortRandomPivot = (callback:(arg0: boolean) => void) => {
    return quickSort(callback, true);
  }
  const heapSort = (callback:(arg0: boolean) => void) => {
    const animations = getHeapSortAnimations(array);
    return animateSorting(callback, animations);
  }

  const bubbleSort = (callback:(arg0: boolean) => void) => {
    const animations = getBubbleSortAnimations(array);
    return animateSorting(callback, animations);
  }

  const onSortBtnClick =(callback:(arg0: boolean) => void, sortingCallback: (arg0: (arg1: boolean) => void) => void): void => {
    callback(true);
    sortingCallback(callback);
  }
  // // NOTE: This method will only work if your sorting algorithms actually return
  // // the sorted arrays; if they return the animations (as they currently do), then
  // // this method will be broken.
  // const testSortingAlgorithms = () => {
  //   for (let i = 0; i < 100; i++) {
  //     const array = [];
  //     const length = randomIntFromInterval(1, 1000);
  //     for (let i = 0; i < length; i++) {
  //       array.push(randomIntFromInterval(-1000, 1000));
  //     }
  //     const javaScriptSortedArray = array.slice().sort((a, b) => a - b);
  //     const mergeSortedArray = getMergeSortAnimations(array.slice());
  //     console.log(arraysAreEqual(javaScriptSortedArray, mergeSortedArray));
  //   }
  // }
  useEffect(() => {
    resetArray();
  },[arraySize]);
  useEffect(() => {
    resetArrayBarColor();
  },[array])
  return (
    <Container maxWidth={false} component="div">
      <SortingBtnGroup arraySize ={arraySize} ARRAY_SIZE_MAX = {ARRAY_SIZE_MAX} setArraySize={setArraySize}
      setAnimationSpeed={setAnimationSpeed} animationSpeed={animationSpeed} ANIMATION_SPEED_MAX={ANIMATION_SPEED_MAX}
        resetArray={resetArray} onSortBtnClick={onSortBtnClick} mergeSort={mergeSort} quickSort={quickSort} 
        quickSortRandomPivot={quickSortRandomPivot} heapSort={heapSort} bubbleSort={bubbleSort}></SortingBtnGroup>
      <Box className="array-container" minHeight='550px' minWidth='1400px' justifyContent={'center'}
        sx={{ 
          p: 2, display: 'flex',
          flexWrap: 'wrap',
          alignContent: 'flex-end', alignItems: 'flex-end' 
        }}>
        {array.map((value, idx) => (
          <Box
            className="array-bar"
            key={idx}
            style={{
              backgroundColor: PRIMARY_COLOR,
              height: `${value}px`,
            }}></Box>
        ))}
      </Box>
    </Container>
  );
}